const Tooltip = require("app/shared/components/Tooltip/tooltip");
const pluralize = require("app/util/formatter/text").pluralize;

const ActivitiesCount = React.createClass({
  propTypes: {
    count: React.PropTypes.number.isRequired,
    pending: React.PropTypes.bool
  },

  threshold: 100,

  numeral: function() {
    if (this.props.count === 0) {
      return "Sem";
    } else if (this.props.count > this.threshold) {
      return `${this.threshold}+`;
    } else {
      return this.props.count;
    }
  },

  text: function() {
    const isZero = this.props.count === 0;

    const text = pluralize("tarefa", "tarefas", this.props.count, isZero);

    return text + " para ";
  },

  shouldShowTooltip: function() {
    return this.props.count > this.threshold;
  },

  render: function() {
    let inner = <span className="d-ib"><strong>{this.numeral()}</strong> {this.text()} </span>;

    return (
      <span className="filter-label hidden-md">
        {this.shouldShowTooltip()
          ? <Tooltip left title={this.props.count.toString()}>{inner}</Tooltip>
          : inner
        }
      </span>
    );
  }
});

module.exports = ActivitiesCount;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/ActivityList/activities-count.jsx